<template>
  <vs-popup title="Relatório de Disparos de Campanhas" :active.sync="isActive" @close="close()">
    <div class="report-form">
      <div class="form-group">
        <label>Tipo de Campanha</label>
        <div class="d-flex">
          <vs-checkbox v-model="webhooksData['sms']">
            <p class="font-medium"> SMS </p>
          </vs-checkbox>
          <vs-checkbox v-model="webhooksData['email']" class="ml-4">
            <p class="font-medium"> Email </p>
          </vs-checkbox>
        </div>
      </div>

      <div class="form-group">
        <label>Data Inicial</label>
        <flat-pickr
          :config="configDateTimePickerStartAt"
          v-model="webhooksData['startAt']"
          placeholder="Escolha um dia"
        />
      </div>

      <div class="form-group">
        <label>Data Final</label>
        <flat-pickr
          :config="configDateTimePickerFinishAt"
          v-model="webhooksData['finishAt']"
          placeholder="Escolha um dia"
        />
      </div>

      <div class="form-actions">
        <vs-button
          type="filled"
          :disabled="missingParameters"
          @click="downloadWebhooks"
        >
          Download
        </vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import {mapGetters} from 'vuex';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import {Portuguese} from 'flatpickr/dist/l10n/pt.js';

export default {
  name: 'WebhooksReport',
  components: {flatPickr},
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    tenantName: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['token']),
    missingParameters() {
      return (
        !this.webhooksData['startAt']  || this.webhooksData['startAt']  === '' ||
        !this.webhooksData['finishAt'] || this.webhooksData['finishAt'] === '' ||
        (!this.webhooksData['sms'] && !this.webhooksData['email'])
      )
    }
  },
  data() {
    return {
      webhooksData: {
        sms: false,
        email: false,
        startAt: '',
        finishAt: '',
        tenantName: '',
      },
      configDateTimePickerFinishAt: null,
      configDateTimePickerStartAt: {
        enableTime: true,
        noCalendar: false,
        dateFormat: "d/m/Y H:i:s",
        locale: Portuguese,
      }
    }
  },
  methods: {
    close() {
      this.webhooksData = {};
      this.$emit('isActiveFalse');
    },
    parseDateToISO(dateString) {
      const [datePart, timePart] = dateString.split(' ');
      const [day, month, year]   = datePart.split('/');
      return `${year}-${month}-${day} ${timePart}`;
    },
    downloadWebhooks() {
      if (this.missingParameters) {
        return this.$vs.notify({
          color: 'warning',
          title: 'Preencha todos os campos.'
        });
      }

      this.$store.dispatch('generateCampaignStatusWebhook', {
        token: this.token,
        tenantName: this.tenantName,
        startAt: this.parseDateToISO(this.webhooksData.startAt),
        finishAt: this.parseDateToISO(this.webhooksData.finishAt),
        type: {
          1: this.webhooksData.sms,
          3: this.webhooksData.email
        }
      })
      .then(() => {
        this.$vs.notify({
          color: 'success',
          title: 'O upload dos dados dos disparos será feito no Bucket da Funcional em breve!',
          time: 15000
        });
        this.$emit('close');
      })
      .catch(exception => console.error(exception));
    }
  },
  watch: {
    isActive(value) {
      if (!value) {
        this.webhooksData = {
          sms: false,
          email: false,
          startAt: '',
          finishAt: '',
          tenantName: '',
        };
      }
    },
    'webhooksData.startAt'(newValue) {
      this.configDateTimePickerFinishAt.minDate = newValue;
      this.$forceUpdate();
    }
  },
  created() {
    this.configDateTimePickerFinishAt = {
      ...this.configDateTimePickerStartAt,
      minDate: this.webhooksData.startAt,
    };
  }
}
</script>

<style lang="scss" scoped>
.report-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
</style>
